<template>
  <v-app>
    <v-app-bar color="header" elevation="2">
      <template v-slot:prepend>
        <v-app-bar-nav-icon @click.stop="isVisibleDrawer = !isVisibleDrawer;"></v-app-bar-nav-icon>
      </template>
      <v-app-bar-title class="ms-2">多点計測環境ムラ可視化ツール</v-app-bar-title>
    </v-app-bar>

    <v-navigation-drawer temporary elevation="3" width="290" v-model="isVisibleDrawer">

      <v-list nav>

        <v-list-item
          :title="userName"
          :subtitle="(userID === '') ? 'ログインしてください' : ('ユーザーID：' + userID)">
          <template v-slot:prepend>
            <v-avatar>
              <v-icon>mdi-account</v-icon>
            </v-avatar>
          </template>
        </v-list-item>

        <v-list-item v-on:click="logout" :disabled="(userID === '')">
          <v-list-item-title>ログアウト</v-list-item-title>
        </v-list-item>

        <v-divider class="mt-1 mb-3"></v-divider>

        <v-list-subheader>
          その他機能
        </v-list-subheader>

        <v-list-item to="command-communication">
          <template v-slot:prepend>
            <v-icon>mdi-remote</v-icon>
          </template>

          <v-list-item-title>子機CO2センサ大気校正</v-list-item-title>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-container fluid>

        <router-view v-if="isAuthenticated" />

        <authentication-view v-else />

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { ref, onMounted } from 'vue';

import axios from 'axios';

import AuthenticationView from './views/AuthenticationView.vue';

export default {
  components: {
    AuthenticationView
  },
  setup() {

    const isVisibleDrawer = ref(false);

    const isAuthenticated = ref(window.sessionStorage.getItem('token') != null);

    const userName = ref('');
    const userID = ref(window.sessionStorage.getItem('userID') != null ? window.sessionStorage.getItem('userID') : '');

    onMounted(() => {
      if (isAuthenticated.value) {

        axios.get(
          'https://trial.agrilog.jp/v2/users/me',
          { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("token") } }
        ).then((response) => {

          userName.value = response.data.user_name;

        });

      }
    });

    const logout = () => {

      window.sessionStorage.clear();
      window.location.reload();

    };

    return {
      isVisibleDrawer,

      isAuthenticated,

      userName,
      userID,

      logout
    }

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
